import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SaveRegionsMutationVariables = Types.Exact<{
  regionIds: ReadonlyArray<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input'];
}>;


export type SaveRegionsMutationPage = { readonly __typename?: 'RootMutationType', readonly saveRegions: boolean };


export const SaveRegionsDocument = gql`
    mutation SaveRegions($regionIds: [Int!]!) {
  saveRegions(regionIds: $regionIds)
}
    `;
export type SaveRegionsMutationFn = Apollo.MutationFunction<SaveRegionsMutationPage, SaveRegionsMutationVariables>;

/**
 * __useSaveRegionsMutation__
 *
 * To run a mutation, you first call `useSaveRegionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveRegionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveRegionsMutation, { data, loading, error }] = useSaveRegionsMutation({
 *   variables: {
 *      regionIds: // value for 'regionIds'
 *   },
 * });
 */
export function useSaveRegionsMutation(baseOptions?: Apollo.MutationHookOptions<SaveRegionsMutationPage, SaveRegionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveRegionsMutationPage, SaveRegionsMutationVariables>(SaveRegionsDocument, options);
      }
export type SaveRegionsMutationHookResult = ReturnType<typeof useSaveRegionsMutation>;
export type SaveRegionsMutationResult = Apollo.MutationResult<SaveRegionsMutationPage>;
export type SaveRegionsMutationOptions = Apollo.BaseMutationOptions<SaveRegionsMutationPage, SaveRegionsMutationVariables>;